import React from 'react';
import { useMetaPixel } from './src/hooks/useMetaPixel';
import { Hero } from './src/components/Hero';
import { BeforeAfter } from './src/components/BeforeAfter';
import { PainPoints } from './src/components/PainPoints';
import { WhatsIncluded } from './src/components/WhatsIncluded';
import { Bonuses } from './src/components/Bonuses';
import { Offer } from './src/components/Offer';
import { Guarantee } from './src/components/Guarantee';
import { Testimonials } from './src/components/Testimonials';
import { About } from './src/components/About';
import { Faq } from './src/components/Faq';
import { FinalCta } from './src/components/FinalCta';
import { Footer } from './src/components/Footer';
import { FloatingCta } from './src/components/FloatingCta';
export function App() {
  useMetaPixel();
  return <main className="w-full min-h-full bg-brand-cream font-sans text-brand-purpleDark" data-id="element-0">
      <Hero data-id="element-1" />
      <BeforeAfter data-id="element-2" />
      <PainPoints data-id="element-3" />
      <WhatsIncluded data-id="element-4" />
      <Bonuses data-id="element-5" />
      <Offer data-id="element-6" />
      <Guarantee data-id="element-7" />
      <Testimonials data-id="element-8" />
      <About data-id="element-9" />
      <Faq data-id="element-10" />
      <FinalCta data-id="element-11" />
      <Footer data-id="element-12" />
      <FloatingCta data-id="element-13" />
    </main>;
}